import { X } from "lucide-react";
import { type ToastItem, useToasts } from "@/hooks/useToast";
import { cn } from "@/lib/utils";

const TONES: Record<ToastItem["kind"], string> = {
  success: "bg-acid",
  error: "bg-tape text-ink",
  info: "bg-cream",
};

export function ToastViewport() {
  const { toasts, dismiss } = useToasts();
  if (toasts.length === 0) return null;

  return (
    <div className="pointer-events-none fixed bottom-4 right-4 z-[80] flex w-[min(92vw,340px)] flex-col gap-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={cn(
            "pointer-events-auto animate-slam border-[3px] border-ink p-3 shadow-smash",
            TONES[toast.kind],
          )}
          role="status"
        >
          <div className="flex items-start gap-2">
            <div className="min-w-0 flex-1">
              <p className="font-slam text-lg uppercase leading-none">
                {toast.title}
              </p>
              {toast.message ? (
                <p className="mt-2 text-xs font-medium leading-relaxed">
                  {toast.message}
                </p>
              ) : null}
            </div>
            <button
              type="button"
              onClick={() => dismiss(toast.id)}
              className="border-[2px] border-ink p-0.5"
              aria-label="Dismiss"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
